import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'

// import './config/global'

import SlideVerify from 'vue-monoplasty-slide-verify'
import Cookies from 'vue-cookies'

import LemonIMUI from 'lemon-imui'
import 'lemon-imui/dist/index.css'
Vue.use(LemonIMUI)

Vue.use(ElementUI)
Vue.use(SlideVerify)

Vue.prototype.$cookies = Cookies // 添加到实例

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
